import './App.css';
import React from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import base, { firebaseApp } from './base';
import styled from 'styled-components';
import Time from './components/Time';
import Tasks from './components/Tasks';
import Login from './Login';

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0984e3;
  width: 100%;
  height: 200px;
`

const Logout = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  padding: 5px 10px 10px 10px;
  background: none;
  border: none;
  color: #fff;
  font-size: 14px;

  :hover {
    cursor: pointer;
    background-color: #065da0;
  }
`

class App extends React.Component {

  state = {
    uid: null,
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      if(user) {
        this.authHandler({user});
      }
    })
  }

  authHandler = async (authData) => {
    await base.post(`/users/${authData.user.uid}`, {
      data: {
        email: authData.user.email,
        name: authData.user.displayName,
        profile_image: authData.user.photoURL
      }
    });

    this.setState({
      uid: authData.user.uid,
    });
  }

  authenticate = provider => {
    const authProvider = new firebase.auth[`${provider}AuthProvider`]();
    firebaseApp
      .auth()
      .signInWithPopup(authProvider)
      .then(this.authHandler);
  }

  logout = async () => {
    await firebase.auth().signOut();
    this.setState({ uid: null });
  }

  render() {
    if (!this.state.uid) {
      return (
        <div className="app login">
          <Login authenticate={this.authenticate}/>
        </div>
      );
    }

    return (
      <div className="app">
        <Header>
          <Time/>
          <Logout onClick={this.logout}>Log Out</Logout>
        </Header>
        <Tasks uid={this.state.uid}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js